import { ReactNode } from "react";

import { css } from "@compiled/react";
import { useInView } from "react-intersection-observer";

import { media } from "@atlaskit/primitives";
import { token } from "@atlaskit/tokens";

import { Adg4Button } from "@/components/adg4/button/src";
import {
    Row,
    TypographyStyles,
    ProductKeyTypes
} from "@/libraries/wpl/foundations/src";

const CtaStyles = css({
    "maxWidth": "1440px",
    "margin": `${token("space.200")} auto`,
    ".polygon": {
        background: "var(--background-color)",
        clipPath:
            "polygon(1.5% 0, 70% 3%, 70% 13%, 97% 9%, 97.5% 89%, 40% 100%, 39.9% 90%, 1% 88%)",
        [media.below.sm]: {
            clipPath:
                "polygon(0 0, 100% 4%, 100% 97%, 28% 100%, 28% 87%, 0 87%)"
        },
        padding: `${token("space.1000")} 0`
    },

    "h3, p": {
        color: "#fff",
        marginBlockEnd: token("space.200")
    },
    "textAlign": "center",
    "&.is-visible": {}
});

type CtaWithPolygonBackgroundProps = {
    header: ReactNode | string;
    paragraph?: ReactNode | string;
    ctaText: ReactNode | string;
    ctaUrl: string;
    ctaLabel: string;
    productKey: ProductKeyTypes;
    backgroundColor?: "#1868DB" | "#101214";
};

export const ADG4CtaWithPolygonBackground = ({
    header,
    paragraph,
    ctaText,
    ctaUrl,
    ctaLabel,
    productKey,
    backgroundColor = "#101214"
}: CtaWithPolygonBackgroundProps) => {
    const { ref: scrollRef, inView: sectionIsVisible } = useInView();

    const noParagraphSpacing = !paragraph
        ? token("space.400")
        : token("space.200");

    return (
        <TypographyStyles>
            <section
                css={CtaStyles}
                ref={scrollRef}
                className={sectionIsVisible ? "is-visible" : ""}
            >
                <div
                    style={
                        {
                            "--background-color": backgroundColor
                        } as React.CSSProperties
                    }
                    className="polygon"
                >
                    <Row layout="8">
                        <div>
                            <h3 style={{ marginBottom: noParagraphSpacing }}>
                                {header}
                            </h3>
                            {paragraph && (
                                <Row layout="8">
                                    <p className=".body-lg">{paragraph}</p>
                                </Row>
                            )}
                            <Adg4Button
                                variant="secondary"
                                color="white"
                                href={ctaUrl}
                                dataEventProps={{
                                    "data-product-key": productKey,
                                    "data-event": "clicked",
                                    "data-event-component": "linkButton",
                                    "data-event-container": "ctaSection",
                                    "data-label-english": ctaLabel
                                }}
                            >
                                {ctaText}
                            </Adg4Button>
                        </div>
                    </Row>
                </div>
            </section>
        </TypographyStyles>
    );
};
